module.exports = __webpack_public_path__ + "img/eticket-list.28544c71.svg";